(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ramped-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ramped-mega-menu')) {
  customElements.define('ramped-mega-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.details = this.querySelector('.ru-mega');
      this.querySelector('.ru-mega__close').addEventListener('click', () => this.close(true), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(true); }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close(false);
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      }, options);
    }
    close(focus) {
      if (!this.details.open) return;
      this.details.open = false;
      if (focus) this.querySelector('.ru-mega__trigger').focus();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ramped-mobile-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ramped-mobile-nav')) {
 customElements.define('ramped-mobile-nav', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const header = this.closest('header');
   const button = header.querySelector('[data-ru-menu-toggle]');
   const menu = header.querySelector('#navbarSupportedContent');
   if (!button || !menu) return;
   const media = window.matchMedia('(max-width: 991px)');
   const setOpen = open => {
    menu.classList.toggle('show', open);
    button.setAttribute('aria-expanded', String(open));
    if (!open) menu.querySelectorAll('details[open]').forEach(item => item.open = false);
   };
   button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'), {signal:this.abort.signal});
   header.addEventListener('keydown', event => {
    if (event.key === 'Escape' && media.matches && menu.classList.contains('show')) {setOpen(false); button.focus();}
   }, {signal:this.abort.signal});
   document.addEventListener('click', event => {
    if (media.matches && !header.contains(event.target)) setOpen(false);
   }, {signal:this.abort.signal});
   media.addEventListener('change', () => setOpen(false), {signal:this.abort.signal});
  }
  disconnectedCallback() {this.abort?.abort();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ramped-search-dialog')) {
  customElements.define('ramped-search-dialog', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.closest('.shopify-section')?.querySelector('#open-search-popup');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        dialog.querySelector('input[type=search]').focus();
      }, options);
      this.querySelector('.ru-search-dialog__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => trigger.focus(), options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
